import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Dieutrathongke {
  name: string;
  api_token: string;
}

export interface DieutrathongkeInfo {
  errors: unknown;
  listDieutrathongke: Dieutrathongke;
  isAuthenticated: boolean;
}

@Module
export default class DieutrathongkeModule
  extends VuexModule
  implements DieutrathongkeInfo
{
  errors = {};
  listDieutrathongke = {} as Dieutrathongke;
  dieutrathongkeDetail = {};
  isAuthenticated = !!JwtService.getToken();

  get getListDieutrathongke() {
    return this.listDieutrathongke;
  }

  get getDieutrathongkeDetail() {
    return this.dieutrathongkeDetail;
  }

  @Mutation
  [Mutations.DIEUTRATHONGKE_LIST_DATA](listDieutrathongke) {
    this.listDieutrathongke = listDieutrathongke;
  }

  @Mutation
  [Mutations.DIEUTRATHONGKE_DETAIL_DATA](dieutrathongkeDetail) {
    this.dieutrathongkeDetail = dieutrathongkeDetail;
  }

  @Action
  [Actions.DIEUTRATHONGKE_LIST](payload) {
    console.log("payload", payload);
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/dieutra_tks", payload)
        .then((data) => {
          this.context.commit(Mutations.DIEUTRATHONGKE_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.DIEUTRATHONGKE_DETAIL](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/dieutra_tks/${payload.id}/detail`)
        .then((data) => {
          this.context.commit(Mutations.DIEUTRATHONGKE_DETAIL_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.DIEUTRATHONGKE_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`dieutra_tks/${payload.id}/delete`, payload)
        .then((res) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.DIEUTRATHONGKE_UPSERT](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const idPath = payload.get("id") ? `/${payload.get("id")}` : "";
      return ApiService.post(`/dieutra_tks/upsert${idPath}`, payload)
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
